module.exports = "https://tutorchat.chegg.com/static/media/ic-scratchpad.df9907e5.svg";